// =========================================================
// ARMONIA COMPACT MERCHANDISING CARD PURCHASE
// - Native Ajax cart add with cart-drawer refresh
// - Compact inline variant select
// - "Dodato ✓" confirmation state
// - Reusable in collection merchandising + recommendations
// =========================================================

if (!customElements.get('armonia-compact-purchase')) {
  customElements.define(
    'armonia-compact-purchase',
    class ArmoniaCompactPurchase extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.select = this.querySelector('[data-compact-variant-select]');
        this.hiddenVariant = this.querySelector('[data-compact-variant-id]');
        this.button = this.querySelector('[data-compact-add]');
        this.buttonText = this.querySelector('[data-compact-add-text]');
        this.error = this.querySelector('[data-compact-error]');
        this.card = this.closest('.armonia-compact-product');
        this.currentPrice = this.card?.querySelector('[data-compact-current]');
        this.comparePrice = this.card?.querySelector('[data-compact-compare]');

        if (!this.button) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.select?.addEventListener('change', () => this.onVariantChange(), { signal });
        this.button.addEventListener('click', (event) => this.addToCart(event), { signal });

        if (this.select) this.onVariantChange();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        window.clearTimeout(this.addedTimer);
        this.initialized = false;
      }

      get variantId() {
        return this.select?.value || this.hiddenVariant?.value || '';
      }

      onVariantChange() {
        const option = this.select?.selectedOptions?.[0];
        const variantId = option?.value || '';

        this.clearError();
        this.button.disabled = !variantId;

        if (this.buttonText) {
          this.buttonText.textContent = variantId ? 'Dodaj u korpu' : 'Izaberite opciju';
        }

        if (!option || !variantId) return;

        const price = option.dataset.price || '';
        const compare = option.dataset.compare || '';

        if (price && this.currentPrice) this.currentPrice.textContent = price;

        if (this.comparePrice) {
          this.comparePrice.textContent = compare;
          this.comparePrice.hidden = !compare;
        }
      }

      async addToCart(event) {
        event.preventDefault();

        const variantId = this.variantId;
        if (!variantId || this.button.disabled) return;

        this.clearError();
        this.setLoading(true);

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        try {
          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
          });

          const data = await response.json();

          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Cart add failed');
          }

          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.refreshAndOpen === 'function') {
            await drawer.refreshAndOpen(this.button);
          } else {
            await window.armoniaSyncCartBadge?.();
          }

          this.showAdded();
        } catch (error) {
          console.error('Armonia compact add to cart failed.', error);
          this.showError('Trenutno nije moguće dodati proizvod. Pokušajte ponovo.');
        } finally {
          this.setLoading(false);
        }
      }

      updateCartIcon(sectionHtml) {
        if (!sectionHtml) return;

        const current = document.querySelector('#cart-icon-bubble');
        if (!current) return;

        const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const next = parsed.querySelector('#cart-icon-bubble');

        if (next) current.innerHTML = next.innerHTML;
      }

      setLoading(isLoading) {
        if (!this.button || !this.buttonText) return;

        this.button.classList.toggle('is-loading', isLoading);
        this.button.setAttribute('aria-busy', isLoading ? 'true' : 'false');

        if (isLoading) {
          this.button.disabled = true;
          this.buttonText.textContent = 'Dodavanje...';
        } else if (!this.button.classList.contains('is-added')) {
          this.button.disabled = !this.variantId;
          this.buttonText.textContent = this.variantId ? 'Dodaj u korpu' : 'Izaberite opciju';
        }
      }

      showAdded() {
        if (!this.button || !this.buttonText) return;

        this.button.classList.add('is-added');
        this.button.disabled = false;
        this.buttonText.textContent = 'Dodato ✓';

        window.clearTimeout(this.addedTimer);
        this.addedTimer = window.setTimeout(() => {
          this.button.classList.remove('is-added');
          this.button.disabled = !this.variantId;
          this.buttonText.textContent = this.variantId ? 'Dodaj u korpu' : 'Izaberite opciju';
        }, 1400);
      }

      showError(message) {
        if (!this.error) return;
        this.error.textContent = message;
        this.error.hidden = false;
      }

      clearError() {
        if (!this.error) return;
        this.error.textContent = '';
        this.error.hidden = true;
      }
    },
  );
}
